import axios from "axios";

const instanceMerchant = axios.create({
  // baseURL: "http://localhost:9000/api/v1",
  baseURL: "https://fatora-sa.herokuapp.com/api/v1",
  headers: {
    Authorization: "Bearer " + localStorage.getItem("Token"),
    // Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NzkyODU5NTcsInVzZXIiOnsiX2lkIjoiNjQwOWY3Y2M0ZTM5Yzg0MWMzZjAwNjU1IiwiZGlzcGxheU5hbWUiOiJJdWx1IiwiZW1haWwiOiJsdWx1QGdtYWlsLmNvbSIsImFkbWluIjpmYWxzZSwiYWRkcmVzcyI6IiIsImNpdHkiOiIiLCJuZWlnaGJvcmhvb2QiOiIiLCJwaG9uZSI6IiJ9LCJpYXQiOjE2Nzg0MjE5NTd9.EjjZWHRzcKns8d1Pcq45gDIdkeVcUcAg5pKpzarj5pk",
    // Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzk0OTU2NzUsImNvbXBhbnkiOnsiX2lkIjoiNjIxNjBiYzgxYzVjZWVjMTI1NzgwNzk0IiwiY29tcGFueU5hbWUiOiJhdGVyICIsImVtYWlsIjoiYXRlckBnbWFpbC5jb20iLCJhY3RpdmUiOmZhbHNlLCJhZG1pbiI6dHJ1ZSwic3VwZXJBZG1pbiI6ZmFsc2UsImNpdHkiOiJKZWRkYWgiLCJhZGRyZXNzIjoi2KfZhNio2YjYp9iv2YoiLCJwaG9uZSI6IjA1NjExODc4NTYiLCJ1cmwiOiJodHRwczovL2F0ZXItYXBwLndlYi5hcHAiLCJ0YXhOdW1iZXIiOiIifSwiaWF0IjoxNjc4NjMxNjc1fQ.EQHoU8uWIIcDG7stJPIDoi4NLcnW9BfxBbdp5WkhkKA",
  },
});

instanceMerchant.defaults.headers.post["Content-Type"] = "application/json";

export default instanceMerchant;
